// @flow

import React from 'react';
import KpiSelector from './KpiSelector';
import { timestampToISO } from '../../../../utils/dateUtils';

type Props = {
  store: Object,
  storeBranchLevel: ?string,
}

function StoreDescription(props: Props) {
  return (
    <div className="kpi-selector-container">
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.openingDate"
        value={props.store.openingDate ? timestampToISO(props.store.openingDate) : 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.nextBreakOption"
        value={props.store.nextBreakOption ? timestampToISO(props.store.nextBreakOption) : 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.reversionaryDate"
        value={props.store.revDate ? timestampToISO(props.store.revDate) : 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.closingDate"
        value={props.store.closingDate ? timestampToISO(props.store.closingDate) : 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.configurationWeighting"
        value={`${props.store.confWeighting || 'N/A'} %`}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.locationWeighting"
        value={`${props.store.localWeighting || 'N/A'} %`}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.glaSplit"
        value={(props.store.glaSplit != null && props.store.glaSplit !== 'null') ? props.store.glaSplit : 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.nbSignf"
        value={(props.store.nbSignf != null && props.store.nbSignf !== 'null') ? props.store.nbSignf : 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.branchLevel"
        value={props.storeBranchLevel || 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.zone"
        value={props.store.zoneName || 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.idRetailer"
        value={props.store.retailerId || 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.codstr"
        value={props.store.codstr || 'N/A'}
      />
      <KpiSelector
        label="SIDE_DATA.WHITE_BOARD.idsVisioglobe"
        value={props.store.idVisioglobes ? props.store.idVisioglobes.join(', ') : 'N/A'}
      />
    </div>
  );
}

export default StoreDescription;
